const siteUrl = (process.env.REACT_APP_SITE_URL || "https://www.draxhallhealthgroup.com").replace(
  /\/$/,
  ""
);

const logoUrl = `${siteUrl}/logo.png`;

const address = {
  "@type": "PostalAddress",
  streetAddress: "Shop 14, Knutsford Express Business Center 12",
  addressLocality: "Drax Hall Commercial Estate",
  addressRegion: "St. Ann",
  addressCountry: "JM",
};

const openingHoursSpecification = [
  {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "08:00",
    closes: "18:00",
  },
  {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: "Saturday",
    opens: "08:00",
    closes: "16:00",
  },
];

const phone = "+1-876-972-0514";

const sameAs = [
  "https://www.instagram.com/draxhall_medsurge/",
  "https://facebook.com/draxhallmedicalandsurgical",
];

export { siteUrl, logoUrl, address, openingHoursSpecification, phone, sameAs };

